import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FileUp, List, ShieldBan, Users } from "lucide-react";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";

const ContactsLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSection, setSectionPath, setPage } = useBreadcrumbs();

  const getActiveTab = () => {
    if (location.pathname.includes("/contacts/lists")) {
      return "lists";
    }
    if (location.pathname.includes("/contacts/dnc")) {
      return "dnc";
    }
    if (location.pathname.includes("/contacts/imports")) {
      return "imports";
    }
    if (location.pathname.includes("/contacts/phone-numbers")) {
      return "phone-numbers";
    }
    return "all";
  };

  const handleTabChange = (value: string) => {
    if (value === "all") {
      navigate("/contacts/all");
    }
    if (value === "lists") {
      navigate("/contacts/lists");
    }
    if (value === "dnc") {
      navigate("/contacts/dnc");
    }
    if (value === "imports") {
      navigate("/contacts/imports");
    }
    if (value === "phone-numbers") {
      navigate("/contacts/phone-numbers");
    }
  };

  useEffect(() => {
    setSection("Contacts");
    setSectionPath("/contacts");
    setPage("");
  }, [setSection, setSectionPath, setPage]);

  return (
      <div className="flex flex-col h-full">
        <div className="border-b border-border px-6 py-4">
          <Tabs value={getActiveTab()} onValueChange={handleTabChange}>
            <TabsList>
              <TabsTrigger value="all" className="gap-2">
                <Users className="h-4 w-4" />
                Contacts
              </TabsTrigger>
              <TabsTrigger value="lists" className="gap-2">
                <List className="h-4 w-4" />
                Lists
              </TabsTrigger>
              <TabsTrigger value="dnc" className="gap-2">
                <ShieldBan className="h-4 w-4" />
                Do Not Contact
              </TabsTrigger>
              <TabsTrigger value="imports" className="gap-2">
                <FileUp className="h-4 w-4" />
                Imports
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>

        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>
  );
};

export default ContactsLayout;
